<script>
	/**
	 * This top-level route displays an assessment of an assignment as well
	 * as data associated with the article of the assignment.
	 *
	 * SUB ROUTES
	 *
	 * This route has 3 sub-routes which aren't arranged as tabs.
	 *
	 * The first part of the hash of the URL (split on /) drives which sub-route
	 * loads.
	 *
	 * These routes are:
	 * - (no hash)            ./class-admin/classes.vue - display a list of classes
	 * - #invite/<class-code> ./class-admin/invite.vue  - display directions to invite students to a class
	 * - #roster/<class-code> ./class-admin/roster.vue  - show a list of students that are in the class
	 *
	 */
	const utilities = require('utilities');
	const accountService = require('services/accountService');
	const _ = require('underscore');
	const classService = require('services/classService');
	const classUtilities = require('utilities/classUtilities');
	const model = require('model/model');
	const page = require('page');
	const hashStore = require('model/stores/hashStore');
	// var editStudent = null;
	var editClassCode = null;
	const moment = require('moment');
	const accountSettingsUtilities = require('utilities/accountSettingsUtilities');
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const i18n = require('i18n/i18n');

	const studentGroupUtilities = require('utilities/studentGroupUtilities');
	const addStudentsToGroup = studentGroupUtilities.addStudentsToGroup;
	const removeStudentsFromGroup = studentGroupUtilities.removeStudentsFromGroup;

	const { authenticateWithGoogleClassroom, isInvalidatingGoogleError /* isKnownGoogleClass */ } = require('utilities/googleClassroomUtilities');

	const pubsub = require('events/pubsub');

	const fireEvent = analyticsUtilities.fireEvent;
	const STUDENT_ELL_CHANGE = analyticsUtilities.events.STUDENT_ELL_CHANGE;
	const CLASS_STATUS_MAP = classUtilities.STATUS_MAP;
	const UNENROLL_MESSAGE_DISMISS = accountSettingsUtilities.settings.UNENROLL_MESSAGE_DISMISS;

	const languageOptions = i18n.getLanguageList().map(l =>
		_.assign({}, l, {
			text: 'On - ' + l.displayValue,
			value: l.languageCode
		})
	);

	const ellChoices = [...languageOptions];

	module.exports = {
		props: ['on-ready'],
		components: {
			classes: require('./class-admin/classes.vue').default,
			invite: require('./class-admin/invite.vue').default,
			roster: require('./class-admin/roster.vue').default,
			'validated-form': require('components/validated-form.vue').default,
			'validated-input': require('components/validated-input.vue').default,
			'validated-multiselect': require('components/validated-multiselect.vue').default,
			'info-icon': require('components/svg/info-icon.vue').default
		},
		modelData: [
			'classAdmin',
			'classCode',
			'userContext',
			'welcomeCoteacher',
			'studentGroups',
			'localGCAccessToken',
			'classes',
			'skiRedirect',
			'rosterRedirect',
			'studentLibraryPromo',
			'gcClassList'
		],
		data: function () {
			let now = moment();
			let year = now.get('year');
			let archiveDate = moment('06/01/' + year, 'MM/DD/YYYY');

			if (now.unix() < archiveDate.unix()) {
				archiveDate = moment('06/01/' + (year - 1), 'MM/DD/YYYY');
			}
			let hideNudge = model.get('archiveMessageDismiss');

			return {
				unenrollMessageDismiss: null,
				roster: {},
				unEnrollInProgress: false,
				passwordModalExtra: {
					username: ''
				},
				studentBeforeEdit: {},
				editStudentForm: {
					currentUsername: '',
					firstName: '',
					lastName: '',
					username: '',
					ell: '',
					accountDisabled: false
				},
				ellChoices,
				ellTip:
					'For Article-A-Day only, this provides audio and additional features for students. Teachers decide which students have access to these extra supports. <a href="http://about.readworks.org/ell-extra-supports.html" target="_blank" data-outbound-link="UPDATE_STUDENT_TOOLTIP_ELL">Learn how to turn it on and what it provides.</a>',
				archiveDate,
				hideNudge,
				loadingClasses: false,
				groupLoading: false,
				editStudent: null,
				tokenExpired: false,
				coteacherInvite: null,
				coteacherLoading: false
			};
		},
		computed: {
			subView: function () {
				let classAdmin = this.classAdmin;
				let classCode = this.classCode;

				if ((classCode && classAdmin === 'roster') || classAdmin === 'add') {
					return 'roster';
				} else if (classCode && classAdmin === 'invite') {
					return 'invite';
				}

				return 'classes';
			},
			selectedStudentGroups() {
				let selectedStudent = this.editStudent;
				let groups = this.studentGroups;
				let selectedGroups = [];

				if (selectedStudent) {
					let editStudentGroupsById = {};

					if (selectedStudent.groups) {
						editStudentGroupsById = selectedStudent.groups.reduce((acc, g) => {
							acc[g.id] = g;
							return acc;
						}, {});
					}

					selectedGroups = groups.map(g => {
						return {
							id: g.id,
							text: g.n,
							selected: !!editStudentGroupsById[g.id]
						};
					});
				}
				return selectedGroups;
			},
			needsGoogleAuth() {
				const roster = this.roster;
				/* No GCA check needed - inaccessible in GCA */

				return roster && roster.gcid && (!this.localGCAccessToken || this.tokenExpired) /*  || !this.gcClassList || !isKnownGoogleClass(roster.gcid) */;
			}
		},
		mounted() {
			var self = this;

			model.remove('activeClass');

			accountSettingsUtilities.read(UNENROLL_MESSAGE_DISMISS).then(value => {
				this.unenrollMessageDismiss = value;
			});

			if (this.welcomeCoteacher) {
				model.set({
					classAdmin: 'roster',
					classCode: this.welcomeCoteacher
				});
			}

			self.$on('class-deleted', function (clazCode) {
				var c = _.filter(self.classes, function (claz) {
					return claz.classCode !== clazCode;
				});
				self.classes = c;
			});

			self.$subscribe('update-classes', function (classCode, classNewName) {
				self.loadClasses();
				return false;
			});

			self.loadClasses(true).then(activeClasses => {
				self.$emit('data-ready');
				let showNudge = false;

				let haveElligibleClasses = self.classes && self.classes.some(c => c.uid === this.userContext.uid && c.created < self.archiveDate.unix());
				// Do we own classes older than the archive date?
				if (haveElligibleClasses) {
					showNudge = true;

					//Have we ever dismissed the nudge modal?
					if (showNudge && self.hideNudge) {
						showNudge = false;
					} else if (
						showNudge && // Have we previously archived classes?
						self.classes.some(c => c.status === CLASS_STATUS_MAP.archived)
					) {
						showNudge = false;
					}
				}

				if (showNudge) {
					utilities.openModal('#modal-archive-nudge');
				}

				this.loadingClasses = true;
				return classService
					.getCoteacherInvites()
					.then(result => {
						if (result && result.length) {
							let invite = result[0];
							if (invite && invite.payload) {
								let payload = JSON.parse(invite.payload);
								payload.t = invite.t;
								this.coteacherInvite = payload;
								utilities.openModal('#modal-coteacher-invite');
							}
						} else if (activeClasses && activeClasses.length === 0) {
							utilities.openModal('#modal-create-class');
						}
					})
					.finally(() => {
						this.coteacherLoading = false;
						this.loadingClasses = false;
					});
			});

			// send ready notice to parent
			if (typeof this.onReady === 'function') {
				self.onReady();
			}
		},
		methods: {
			authenticateWithGoogle() {
				authenticateWithGoogleClassroom();
				// Listen for updated token and try again
				let remove = model.change('localGCAccessToken', (token, initial) => {
					if (!initial) {
						this.tokenExpired = false;
						remove();
					}
				});
			},
			updateStudent: function () {
				let editStudent = this.editStudent;
				let editStudentForm = this.editStudentForm;
				let oldEll = editStudent.ell || '';
				let firstName = editStudentForm.firstName;
				let lastName = editStudentForm.lastName;
				let ell = editStudentForm.ell;
				let currentUsername = editStudentForm.currentUsername;
				let data = {
					currentUsername
				};
				let classCode = this.classCode;

				if (oldEll !== ell) {
					data.ell = ell;
				}

				if (editStudent.firstName !== firstName) {
					data.firstName = firstName;
				}

				if (editStudent.lastName !== lastName) {
					data.lastName = lastName;
				}

				if (typeof data.ell !== 'undefined' && oldEll !== ell) {
					let eventData = {
						student: data.currentUsername,
						ell: ell
					};

					fireEvent(STUDENT_ELL_CHANGE, eventData);
				}
				return accountService
					.teacherUpdateStudentAccount(data)
					.then(() => classUtilities.fetchRoster(classCode))
					.then(() => {
						this.closeModals();
						this.editStudent = null;
						pubsub.publish('message-success', 'Updated student');
					})
					.catch(e => {
						pubsub.publish('message-error', 'Failed to update student');
						throw e;
					});
			},
			loadClasses: function (firstCall) {
				this.activeClasses = [];
				this.loadingClasses = true;
				let skiRedirect = this.skiRedirect;
				let studentLibraryPromo = this.studentLibraryPromo;
				const rosterRedirect = this.rosterRedirect;

				return classUtilities
					.loadClasses()
					.then(classes => {
						if (!this.$data) {
							return null;
						}

						let activeClasses = classes.filter(c => c.status !== CLASS_STATUS_MAP.archived);
						let archivedClasses = classes.filter(c => c.uid === this.userContext.uid && c.status === CLASS_STATUS_MAP.archived);

						if (activeClasses.length === 1 && archivedClasses.length === 0 && this.subView === 'classes') {
							// Only redirect to the single class if teacher has no archived classes
							// Don't create history entry for this forward.
							hashStore.forceReplaceState = true;
							model.set('classCode', activeClasses[0].classCode);
							model.set('classAdmin', 'roster');
							hashStore.forceReplaceState = false;
						}
						if (activeClasses.length > 0 && skiRedirect) {
							// SKI Campaign Link
							model.remove('skiRedirect');
							page(`/assignments#!assignmentTab:rms/classCode:${activeClasses[0].classCode}`);
						} else if (activeClasses.length > 0 && (studentLibraryPromo || rosterRedirect)) {
							// Library Campaign Link and Class List Bypass, Journeys
							const rosterView = studentLibraryPromo ? 'library' : 'students';
							hashStore.forceReplaceState = true;
							model.set('classCode', activeClasses[0].classCode);
							model.set('classAdmin', 'roster');
							model.set('rosterView', rosterView);
							hashStore.forceReplaceState = false;
						}
						return activeClasses;
					})
					.finally(() => (this.loadingClasses = false));
			},
			confirmUnenrollment: function () {
				utilities.openModal('#confirm-unenroll');
			},
			reenable: function () {
				let editStudent = this.editStudent;
				return accountService
					.enableStudentAccount({
						uid: editStudent.uid
					})
					.then(function () {
						utilities.closeModals();
					});
			},
			removeSelectedStudent: function () {
				var self = this;
				let editStudent = this.editStudent;

				self.unEnrollInProgress = true;

				return classService
					.unEnrollStudent({
						classCode: editClassCode,
						uid: editStudent.uid
					})
					.then(() => classUtilities.fetchRoster(editClassCode))
					.then(function () {
						utilities.closeModals();
						pubsub.publish('message-success', 'Removed ' + editStudent.firstName + ' ' + (editStudent.lastName || '') + ' from class');
						self.loadClasses();
						studentGroupUtilities.fetchGroups(editClassCode);
					})
					.fin(function () {
						self.unEnrollInProgress = false;
					});
			},
			removeSelectedStudentAndDismiss: function () {
				this.unenrollDismiss();
				this.removeSelectedStudent();
			},
			closeModals: function () {
				utilities.closeModals();
			},
			dismissArchiveMessage: function () {
				utilities.closeModals();
				model.set('archiveMessageDismiss', true);
			},
			maybeUnenroll: function () {
				if (this.unenrollMessageDismiss || this.roster.rosterType === 'student') {
					this.removeSelectedStudent();
				} else {
					this.confirmUnenrollment();
				}
			},
			unenrollDismiss: function () {
				let value = true;
				accountSettingsUtilities.update(UNENROLL_MESSAGE_DISMISS, value);
				this.unenrollMessageDismiss = value;
			},
			editGroups() {
				this.closeModals();
				model.set('rosterView', 'groups');
			},
			editStudentGroupMembership(option) {
				this.groupLoading = true;
				let studentGroups = this.studentGroups;
				let editStudent = this.editStudent;
				let groupId = option.id;
				let classCode = this.classCode;
				let suids = {
					[editStudent.uid]: true
				};
				let token = this.localGCAccessToken;
				let prms = null;
				if (option.selected) {
					prms = removeStudentsFromGroup(groupId, classCode, suids, token)
						.then(() => {
							let groups = [...(editStudent.groups || [])];
							groups = groups.filter(g => g.id !== groupId);
							this.editStudent = _.assign({}, editStudent, {
								groups
							});
						})
						.finally(() => (this.groupLoading = false));
				} else {
					prms = addStudentsToGroup(groupId, classCode, suids, token)
						.then(() => {
							let groups = [...(editStudent.groups || [])];
							let groupToAdd = null;
							studentGroups.some(g => {
								if (g.id === groupId) {
									groupToAdd = g;
								}
								return false;
							});
							groups.push(groupToAdd);
							groups.sort(studentGroupUtilities.groupNameSorter);
							this.editStudent = _.assign({}, editStudent, {
								groups
							});
						})
						.finally(() => (this.groupLoading = false));
				}

				return prms.catch(error => {
					if (isInvalidatingGoogleError(error)) {
						this.tokenExpired = true;
					} else {
						throw error;
					}
				});
			},
			acceptCoteacherInvite() {
				let coteacherInvite = this.coteacherInvite;

				if (coteacherInvite) {
					page('/v2/class/confirmCoteacher?token=' + coteacherInvite.t);
				}
			},
			declineCoteacherInvite() {
				let coteacherInvite = this.coteacherInvite;

				this.coteacherLoading = true;
				classService
					.declineCoteacherInvite({
						t: coteacherInvite.t
					})
					.finally(() => {
						this.coteacherLoading = false;
						utilities.closeModals();
					});
			},
			onClassRenamed(classCode, classNewName) {
				_.each(this.classes, function (c) {
					if (c.classCode === classCode) {
						c.name = classNewName;
					}
				});
				this.classes = utilities.sortObjects(this.classes, 'name');
				// the roster subView tells us of a rename, no need to let it continue to the root
				return false;
			},
			onStudentSelected(student, classCode, roster, modalName) {
				this.editStudent = student;
				editClassCode = classCode;

				this.roster = roster;

				this.passwordModalExtra.username = student.username;

				this.editStudentForm.username = student.username;
				this.editStudentForm.currentUsername = student.username;
				this.editStudentForm.firstName = student.firstName;
				this.editStudentForm.lastName = student.lastName;
				this.editStudentForm.ell = student.ell || '';
				this.editStudentForm.accountDisabled = student.accountDisabled;

				this.studentBeforeEdit = $.extend(true, {}, self.editStudentForm);

				utilities.openModal(modalName || '#modal-edit-student');

				return true;
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.class-admin {
		.google-classroom-button {
			position: relative;

			&.mismatch {
				border: 3px solid $c-red;
				border-radius: 3px;
				color: $c-red;

				.mismatch-icon {
					position: absolute;
					top: 2px;
					right: 2px;
					border-radius: 50%;
					font-size: 0.75rem;
					background-color: $c-white;
				}
			}
		}
	}

	#modal-edit-student .modal-content-main {
		input[type='text'] {
			margin-top: 1rem;
		}

		.ell-select .ell-tip {
			position: absolute;
			top: 0;
			right: 1rem;
			fill: $c-slate-dark;
		}

		.edit-student-buttons {
			display: flex;
			justify-content: space-between;
		}
	}

	.dismiss-message {
		cursor: pointer;

		&:hover {
			color: $c-slate-dark;
			text-decoration: underline;
		}
	}

	// TODO: Remove when enabling student modal group editing
	.validated-multiselect.disabled {
		&.validated-input {
			& + label {
				line-height: 1.5em;
				margin-bottom: 0.5rem;
			}

			&:hover {
				border-color: $c-grey;
			}
		}
	}
</style>
<template>
	<main
		id="content"
		class="main class-admin">
		<component
			:is="subView"
			:classes="classes"
			:archive-date="archiveDate"
			:loading-classes="loadingClasses"
			@class-renamed="onClassRenamed"
			@student-selected="onStudentSelected"></component>
		<!-- start of #modal-edit-student -->
		<div
			id="modal-edit-student"
			class="modal"
			data-modal-window>
			<div class="modal-container">
				<div class="modal-window">
					<div class="modal-window-wrap">
						<button
							class="modal-close"
							data-modal-close>
							<span aria-hidden="true">&times;</span><span class="hidden-visually"> Close</span>
						</button>
						<section class="modal-content">
							<header class="modal-content-header">
								<h2 v-show="!editStudentForm.firstName && !editStudentForm.lastName">Edit Student</h2>
								<h2 v-show="editStudentForm.firstName || editStudentForm.lastName">{{ editStudentForm.firstName }} {{ editStudentForm.lastName }}</h2>
							</header>
							<div class="modal-content-main">
								<validated-form :on-submit="updateStudent">
									<template v-if="editStudentForm.accountDisabled">
										<h2
											class="error-text"
											v-if="editStudentForm.accountDisabled">
											This account was suspended for suspicious activity.
										</h2>
									</template>
									<template v-if="!editStudentForm.accountDisabled">
										<div
											class="margin-bottom-smedium"
											v-show="roster.rosterType == 'teacher'">
											<div class="input-wrapper">
												<validated-input
													class="firstName"
													:class="{
														touched: editStudentForm.firstName
													}"
													type="text"
													required
													v-model.trim="editStudentForm.firstName"
													name="firstName"
													maxlength="64"
													unsafe></validated-input>
												<label
													for=""
													placeholder="First Name"
													alt="First Name"></label>
											</div>
										</div>
										<div
											class="margin-bottom-smedium"
											v-show="roster.rosterType == 'teacher'">
											<div class="input-wrapper">
												<validated-input
													class="lastName"
													:class="{
														touched: editStudentForm.firstName
													}"
													type="text"
													v-model.trim="editStudentForm.lastName"
													name="lastName"
													maxlength="64"
													unsafe></validated-input>
												<label
													for=""
													placeholder="Last Name"
													alt="Last Name"></label>
											</div>
										</div>
										<div class="margin-bottom-smedium ell-select">
											<div class="input-wrapper select-wrapper">
												<select
													v-model="editStudentForm.ell"
													v-touched-field
													class="ell-input touched">
													<option value="">Off</option>
													<option
														v-for="choice in ellChoices"
														:key="choice.value"
														:value="choice.value">
														{{ choice.text }}
													</option>
												</select>
												<label
													placeholder="Article-A-Day ELL and Extra Support Features"
													alt="Article-A-Day ELL and Extra Support Features">
												</label>
												<button
													class="button -link ell-tip"
													v-tooltip="ellTip">
													<info-icon></info-icon>
												</button>
											</div>
										</div>
										<div class="input-wrapper select-wrapper multiselect-wrapper groups">
											<validated-multiselect
												:options="selectedStudentGroups"
												:on-option-toggle="editStudentGroupMembership"
												:loading="groupLoading"
												:disabled="true">
											</validated-multiselect>
											<label
												placeholder="Student Group(s)"
												alt="Student Group(s)">
											</label>
										</div>
										<div class="text-centered margin-bottom-small">
											<a
												@click="editGroups"
												class="link"
												>Edit Groups</a
											>
										</div>
										<div
											class="text-centered margin-bottom-small"
											v-if="needsGoogleAuth">
											<div>To edit student groups, you must authenticate with Google.</div>
											<button
												class="button"
												@click="authenticateWithGoogle">
												Authenticate with Google
											</button>
										</div>
									</template>
									<div class="edit-student-buttons">
										<auto-form-row
											v-if="!editStudentForm.accountDisabled"
											row-class="button"
											v-bind:all-valid="editStudentForm.allValid"
											type="submitWithSurround"
											label="Save">
										</auto-form-row>
										<button
											v-if="editStudentForm.accountDisabled"
											type="button"
											class="button"
											@click.prevent="reenable">
											Re-enable Account
										</button>
										<button
											v-if="userContext && !userContext.organization"
											type="button"
											v-bind:disabled="unEnrollInProgress"
											class="button -outline unenroll-student"
											@click.prevent="maybeUnenroll">
											Remove Student
										</button>
									</div>
								</validated-form>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
		<!-- end #modal-edit-student -->
		<password-modal
			v-bind:extra-data="passwordModalExtra"
			modal-title="Set Student Password"
			mode="student"
			visible-password
			modal-id="modal-change-student-password"></password-modal>
		<modal
			id="confirm-unenroll"
			:centered="true">
			<template slot="header-container">
				<h2>Are you sure?</h2>
			</template>
			<div
				slot="content"
				class="archive-class-modal-body">
				<p>
					Removing {{ editStudentForm.firstName }} {{ editStudentForm.lastName }} from the class will permanently delete all assignment and results data
					for this student.
				</p>
				<div class="-centered">
					<button
						class="button unenroll-confirm-button"
						v-bind:disabled="unEnrollInProgress"
						@click="removeSelectedStudent">
						Yes
					</button>
					<button
						class="button unenroll-cancel-button"
						v-bind:disabled="unEnrollInProgress"
						@click="closeModals">
						No
					</button>
				</div>
				<span
					v-if="!unEnrollInProgress"
					class="dismiss-message font-small text-muted"
					@click="removeSelectedStudentAndDismiss"
					>Remove student and don't ask me again.</span
				>
				<span
					v-if="unEnrollInProgress"
					class="font-small text-muted"
					>Remove student and don't ask me again.</span
				>
			</div>
		</modal>
		<modal
			ref="archiveNudge"
			id="modal-archive-nudge"
			:centered="true">
			<template slot="header-container">
				<h2>Archive old classes</h2>
			</template>
			<div
				slot="content"
				class="archive-class-modal-body">
				<p>
					Please archive old classes. You can use the 'Options' menu on the class roster page or the 'Archive' button on the class admin page. If you don't
					archive old classes, last year's students will still be able to access their old assignments.
				</p>
				<button
					class="button -centered"
					@click="closeModals">
					OK
				</button>
				<span
					class="dismiss-message font-small text-muted"
					@click="dismissArchiveMessage"
					>Don't show this message again.</span
				>
			</div>
		</modal>
		<modal
			id="modal-coteacher-invite"
			:centered="true"
			:loading="coteacherLoading">
			<template slot="header-container">
				<h2>Co-teacher Invitation</h2>
			</template>
			<div
				slot="content"
				class="coteacher-invite-modal-body"
				v-if="coteacherInvite">
				<p>You've been invited to co-teach {{ coteacherInvite.n }} ({{ coteacherInvite.cc }}). What would you like to do?</p>
				<div class="text-centered">
					<button
						class="button -outline decline-coteacher-invite"
						@click="declineCoteacherInvite">
						Decline
					</button>
					<button
						class="button accept-coteacher-invite"
						@click="acceptCoteacherInvite">
						Accept
					</button>
				</div>
			</div>
		</modal>
	</main>
</template>
